import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/arrow_up.svg
 */
const IconArrowUp: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      opacity={0.9}
      d="M12.273 6.011a1.384 1.384 0 00-.249-.034 1.485 1.485 0 00-.256.034 1.273 1.273 0 00-.24.063 1.169 1.169 0 00-.237.14.649.649 0 00-.152.085L.454 15.685a1.334 1.334 0 101.761 2.006l9.81-8.61 9.799 8.61a1.337 1.337 0 001.764-2.006L12.905 6.3a.677.677 0 00-.155-.086 1.136 1.136 0 00-.235-.14 1.323 1.323 0 00-.242-.062z"
      fill="currentColor"
    />
  </svg>
);

export default IconArrowUp;
